"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearHeader = exports.showLevelBuilderSaveButton = exports.showProjectBackedHeader = exports.showMinimalProjectHeader = exports.showProjectHeader = exports.possibleHeaders = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
exports.possibleHeaders = {
    project: 'project',
    minimalProject: 'minimalProject',
    projectBacked: 'projectBacked',
    levelBuilderSave: 'levelBuilderSave',
};
var initialState = {
    currentHeader: undefined,
    getLevelBuilderChanges: undefined,
    overrideHeaderText: undefined,
    overrideOnSaveUrl: undefined,
};
var headerSlice = (0, toolkit_1.createSlice)({
    name: 'header',
    initialState: initialState,
    reducers: {
        showProjectHeader: function (state) {
            state.currentHeader = exports.possibleHeaders.project;
        },
        showMinimalProjectHeader: function (state) {
            state.currentHeader = exports.possibleHeaders.minimalProject;
        },
        showProjectBackedHeader: function (state) {
            state.currentHeader = exports.possibleHeaders.projectBacked;
        },
        showLevelBuilderSaveButton: {
            reducer: function (state, action) {
                state.currentHeader = exports.possibleHeaders.levelBuilderSave;
                state.getLevelBuilderChanges = action.payload.getChanges;
                state.overrideHeaderText = action.payload.overrideHeaderText;
                state.overrideOnSaveUrl = action.payload.overrideOnSaveUrl;
            },
            prepare: function (getChanges, overrideHeaderText, overrideOnSaveUrl) {
                return { payload: { getChanges: getChanges, overrideHeaderText: overrideHeaderText, overrideOnSaveUrl: overrideOnSaveUrl } };
            },
        },
        clearHeader: function (state) {
            state.currentHeader = undefined;
        },
    },
});
exports.showProjectHeader = (_a = headerSlice.actions, _a.showProjectHeader), exports.showMinimalProjectHeader = _a.showMinimalProjectHeader, exports.showProjectBackedHeader = _a.showProjectBackedHeader, exports.showLevelBuilderSaveButton = _a.showLevelBuilderSaveButton, exports.clearHeader = _a.clearHeader;
exports.default = headerSlice.reducer;
